export const qk = {
  activityGroup: (activityGroupId) => ['activity-group', activityGroupId],
  activities: (activityGroupId) => ['activities', activityGroupId],
  previousAnswerGroups: (activityGroupId) => ['previous-answer-groups', activityGroupId],
  secondaryPreviousAnswerGroups: (activityGroupId) => ['secondary-previous-answer-groups', activityGroupId],
  activityGroupAnswers: (activityGroupId, personId) =>
    personId ? ['activity-group-answers', activityGroupId, personId] : ['activity-group-answers', activityGroupId], // Handles both regular answers and answers by personIds (like deceased ancestors answers)
  answerById: ({ activityGroupId, activityGroupAnswerId, cisUserId }) => [
    'answer-by-id',
    { activityGroupId, activityGroupAnswerId, cisUserId },
  ],
  categories: (topicId) => ['categories', topicId],
  familyGroups: (includePendingGroups) => ['family-groups', includePendingGroups],
  familyGroupMembers: (familyGroupId) => ['family-group-members', familyGroupId],
  photosForAlbum: (activityGroupId) => ['photos-for-album', activityGroupId],
  memory: (memoryArtifactId) => ['memory', memoryArtifactId],
  assignedTemple: () => ['assigned-temple'],
  templeDismissed: () => ['temple-dismissed'],
  points: () => ['points'],
  filteringGroups: () => ['filtering-groups'],
  myPoints: () => ['my-points'],
  activityGroupAnswerCount: () => ['activity-group-answer-count'],
  campaigns: () => ['campaigns'],
  sharingPreference: (answerId) => [`sharing-preference-${answerId}`],
  consolidatedAnswers: () => ['consolidated-answers'],
  streaks: () => ['streaks'],
  group: (groupId) => ['get-group', groupId],
  invitations: () => ['invitations-received'],
  activityGroups: (activityGroupId) => ['activity-groups', activityGroupId],
  memoryFromMemories: (artifactId) => ['get-memory-from-memories', artifactId],
  avatarSpecs: () => ['avatar-specs'],
  currentUsersAvatars: () => ['current-users-avatars'],
  templeEligible: () => ['temple-eligible'],
  centerSession: () => ['center-session'],
}
